// Simple SSE client for Kinde Make page
export class KindeSSEClient {
    constructor(sessionId) {
        this.sessionId = sessionId;
        this.eventSource = null;
        this.reconnectAttempts = 0;
        this.maxReconnectAttempts = 5;
        this.reconnectDelay = 1000;

        this.connect();
    }

    connect() {
        try {
            // Connect to SSE endpoint
            const sseUrl = `/sse/${this.sessionId}`;
            console.log('Attempting to connect to SSE:', sseUrl);

            this.eventSource = new EventSource(sseUrl);

            this.eventSource.onopen = () => {
                console.log('SSE connected successfully');
                this.reconnectAttempts = 0;
                this.reconnectDelay = 1000;
            };

            this.eventSource.onmessage = (event) => {
                console.log('SSE message received:', event.data);
                this.handleMessage(JSON.parse(event.data));
            };

            this.eventSource.addEventListener('connected', (event) => {
                console.log('SSE connection event:', JSON.parse(event.data));
            });

            this.eventSource.addEventListener('heartbeat', (event) => {
                return;
            });

            this.eventSource.addEventListener('notification', (event) => {
                console.log(
                    'SSE notification received:',
                    JSON.parse(event.data)
                );
                this.handleNotification(JSON.parse(event.data));
            });

            this.eventSource.addEventListener('reload', (event) => {
                console.log(
                    'SSE reload command received:',
                    JSON.parse(event.data)
                );
                this.handleReload(JSON.parse(event.data));
            });

            this.eventSource.onerror = (error) => {
                console.error('SSE error:', error);
                this.attemptReconnect();
            };
        } catch (error) {
            console.error('Failed to create SSE connection:', error);
        }
    }

    handleMessage(message) {
        console.log('Processing SSE message:', message);
    }

    handleNotification(notification) {
        console.log('Processing notification:', notification);
        // TODO: Display notification in UI
    }

    handleReload(reloadCommand) {
        console.log('Processing reload command:', reloadCommand);
        // TODO: Implement page reload logic
        console.log('Reloading page...');
        const refreshEl = document.querySelector(
            '[data-kui-project-refresh-trigger]'
        );
        if (refreshEl) {
            console.log('Clicking refresh element');
            refreshEl.click();
        }
    }

    attemptReconnect() {
        if (this.reconnectAttempts < this.maxReconnectAttempts) {
            this.reconnectAttempts++;
            this.reconnectDelay *= 2; // Exponential backoff

            console.log(
                `Attempting to reconnect (${this.reconnectAttempts}/${this.maxReconnectAttempts}) in ${this.reconnectDelay}ms`
            );

            setTimeout(() => {
                this.connect();
            }, this.reconnectDelay);
        } else {
            console.error('Max reconnection attempts reached');
        }
    }

    disconnect() {
        if (this.eventSource) {
            this.eventSource.close();
            this.eventSource = null;
        }
    }
}

// Simple WebSocket client for Kinde Make page
export class KindeWebSocketClient {
    constructor(sessionId) {
        this.sessionId = sessionId;
        this.connection = null;
        this.reconnectAttempts = 0;
        this.maxReconnectAttempts = 5;
        this.reconnectDelay = 1000;

        this.connect();
    }

    connect() {
        try {
            // Connect to WebSocket endpoint
            const protocol =
                window.location.protocol === 'https:' ? 'wss:' : 'ws:';
            const wsUrl = `${protocol}//${window.location.host}/ws/${this.sessionId}`;

            console.log('Attempting to connect to WebSocket:', wsUrl);

            this.connection = new WebSocket(wsUrl);

            this.connection.onopen = () => {
                console.log('WebSocket connected successfully');
                this.reconnectAttempts = 0;
                this.reconnectDelay = 1000;
            };

            this.connection.onmessage = (event) => {
                console.log('WebSocket message received:', event.data);
                this.handleMessage(JSON.parse(event.data));
            };

            this.connection.onclose = () => {
                console.log('WebSocket disconnected');
                this.attemptReconnect();
            };

            this.connection.onerror = (error) => {
                console.error('WebSocket error:', error);
            };
        } catch (error) {
            console.error('Failed to create WebSocket connection:', error);
        }
    }

    handleMessage(message) {
        console.log('Processing WebSocket message:', message);

        // For now, just log everything as requested
        switch (message.type) {
            case 'welcome':
                console.log(
                    'Welcome message received:',
                    message.message,
                    'User ID:',
                    message.user_id
                );
                break;
            case 'echo':
                console.log('Echo message received:', message.message);
                break;
            case 'test':
                console.log(
                    'Test message received:',
                    message.message,
                    'Timestamp:',
                    message.timestamp
                );
                break;
            default:
                console.log(
                    'Unknown message type:',
                    message.type,
                    'Full message:',
                    message
                );
        }
    }

    attemptReconnect() {
        if (this.reconnectAttempts < this.maxReconnectAttempts) {
            this.reconnectAttempts++;
            this.reconnectDelay *= 2; // Exponential backoff

            console.log(
                `Attempting to reconnect (${this.reconnectAttempts}/${this.maxReconnectAttempts}) in ${this.reconnectDelay}ms`
            );

            setTimeout(() => {
                this.connect();
            }, this.reconnectDelay);
        } else {
            console.error('Max reconnection attempts reached');
        }
    }

    disconnect() {
        if (this.connection) {
            this.connection.close();
        }
    }

    // Test function to send a message
    sendTestMessage(message) {
        if (this.connection && this.connection.readyState === WebSocket.OPEN) {
            this.connection.send(message);
            console.log('Test message sent:', message);
        } else {
            console.error('WebSocket not connected');
        }
    }
}

// Global instance for testing (for backward compatibility)
window.KindeWebSocketClient = KindeWebSocketClient;
